import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import 'regenerator-runtime/runtime'
import 'core-js/features/string/replace-all'
/* eslint-disable import/no-extraneous-dependencies */
import { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { install } from 'resize-observer'
import App from './App'
import reportWebVitals from './reportWebVitals'
import react from 'react'
import * as CommerceUIComponents from '@engyalo/delivery-ui-components'

import TagManager from 'react-gtm-module'
import { GOOGLE_TAG_MANAGER_DATA_LAYER_NAME } from './consts/defaultConfigValues/defaultConstants'
// expose libs to be used in addons
;(window as any).React = react
;(window as any).commerceUIComponents = CommerceUIComponents

if (!window.ResizeObserver) {
  install()
}
const gtmId = process.env.REACT_APP_GTM_ID

if (gtmId) {
  const tagManagerArgs = {
    gtmId,
    dataLayerName: GOOGLE_TAG_MANAGER_DATA_LAYER_NAME,
  }

  TagManager.initialize(tagManagerArgs)
}

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
